import { useEffect } from "react";
import { IMultiDialogChildren } from "./MultiDialogRoute";
import { useDialogRouteStages } from "./useDialogRouteStages";



/**Used for dialog that are to be closed when they don't have a stage setup */
export function useDialogClose<T extends IMultiDialogChildren>(props: T) {
    const { stages } = useDialogRouteStages(props.history);

    useEffect(() => {
        const stage = stages[props.dialogKey];
        if (!stage) props.onClose();

    }, [props, stages]);
}